
/**
 * restituisce l'id dall'href.
 * https://connect.calamp.co.uk:443/connect/services/accounts/307 --> 307
 * @param {*} href
 */
export function getIdFromHref(href){
    return href.substring(href.lastIndexOf("/")).slice(1);
}

/**
 * usato nel salvataggio liste nei reducer redux
 * @param {*} item
 */
export function copyRecursiveAccountItemSelector(list){

    if(!list) return [];
    if(list.length <= 0) return [];

    var newList = [];

    for(var i=0;i<list.length;i++){

        var currentItem = list[i];
        var clonedItem = {
            title: currentItem.title,
            value: currentItem.value,
            id: currentItem.id,
            depth: currentItem.depth,
            isOpened: currentItem.isOpened,
            isLoading: currentItem.isLoading,
            index: currentItem.index,
            children: [],
            hasBeenLoaded: currentItem.hasBeenLoaded
        }

        newList.push(clonedItem);

        if(currentItem.children && currentItem.children.length > 0){
            var childrens = copyRecursiveAccountItemSelector(currentItem.children);
            clonedItem.children = childrens;
        }
    }

    return newList;
}


/**
 * usato nel salvataggio liste nei reducer redux
 * @param {*} item
 */
export function copyAccountItemSelector(item){

    var clonedItem = {
        title: item.title,
        value: item.value,
        id: item.id,
        depth: item.depth,
        isOpened: item.isOpened,
        isLoading: item.isLoading,
        index: item.index,
        children: [],
        hasBeenLoaded: item.hasBeenLoaded
    }

    /*
        l'array deve essere ricreato da zero, altrimenti ottengo un copia del riferimento, non dell'oggetto!
    */
    if(item.children && item.children.length > 0)
    {
        for(var i=0;i<item.children.length;i++){
            clonedItem.children.push(item.children[i]);
        }
    }

    return clonedItem;
}

/**
 * crea oggetto root per account selector
 * @param {*} account
 */
export function getRootAccountForSelector(account){
    return {
        title: account.title,
        value: getIdFromHref(account.href),
        id: getIdFromHref(account.href),
        depth: 1,
        isOpened: true,
        isLoading: false,
        index: 0,
        children: [],
        hasBeenLoaded: true
    }
}

/**
 * crea oggetto per account selector
 * @param {*} account
 * @param {*} parent
 * @param {*} currentIndex
 */
export function getAccountForSelector(account, parent, currentIndex){

    var child = {
        title: account.title,
        value: getIdFromHref(account.href),
        id: getIdFromHref(account.href),
        depth: parent.depth + 1,
        isOpened: false,
        isLoading: false,
        index: currentIndex,
        parentIndex: parent.index,
        hasBeenLoaded: false,
        children: []
    }

    return child;
}

/**
 * converte carattere in codice ASCII
 * @param {*} a
 */
export function charToAscii(a) { return "&#" + a.charCodeAt(0) + ";"; }

/**
 * cerca item per id
 * @param {*} list
 */
export function getItemFromListById(list, id){

    if(!list) return null;
    if(list.length <= 0) return null;

    if(!id) return null;

    for(var i=0;i<list.length;i++){
        if(list[i].value === id)
        {
            return list[i];
        }

        if(list[i].children && list[i].children.length > 0)
        {
            var found = getItemFromListById(list[i].children, id);
            if(found)
            {
                return found;
            }
        }
    }

    return null;
}

/**
 * Converts a Base64 string to Blob
 * @param {} b64Data Base-64 string
 * @param {} contentType Content type
 * @param {} fileName File name
 * @param {} sliceSize Slice size
 * @returns {} Returns blob
 */
export function base64toBlob(b64Data, contentType, fileName, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType, name: fileName });
    return blob;
}

export function hslToRgb(h, s, l) {
    var r, g, b;

    if (s === 0) {
        r = g = b = l; // achromatic
    } else {
        function hue2rgb(p, q, t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 1 / 2) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }

        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }

    return [Math.floor(r * 255), Math.floor(g * 255), Math.floor(b * 255)];
}

// convert a number to a color using hsl
export function numberToColorHsl(i) {
    // as the function expects a value between 0 and 1, and red = 0° and green = 120°
    // we convert the input to the appropriate hue value
    var hue = i * 1.2 / 360;
    // we convert hsl to rgb (saturation 100%, lightness 50%)
    var rgb = hslToRgb(hue, 1, .5);
    // we format to css value and return
    return 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
}

export function getAddressFromICN(entity){
    var address =  entity.street1 + " " + entity.street2 + ", " + entity.city + " - " + entity.stateProvince + " - " + entity.country;
    return address;
}


// WEBPACK FOOTER //
// ./src/services/miscServices.js